import { Chip, Typography } from "@mui/material";
import type { ReactNode } from "react";
import type { PlaywrightTest } from "./playwright-api";
import { testRowKey } from "./run-test-selection";

interface RunTestListProps {
  tests: PlaywrightTest[];
  selectedKeys: string[];
  artifactCount?: number;
  onSelect: (keys: string[]) => void;
  statusChip: (status?: string) => ReactNode;
}

const RunTestList = ({
  tests,
  selectedKeys,
  artifactCount = 0,
  onSelect,
  statusChip,
}: RunTestListProps) => {
  const allSelected = selectedKeys.length === 0;

  return (
    <div>
      <div
        className={`border-b border-gray-200 py-3 cursor-pointer ${
          allSelected ? "bg-blue-50" : ""
        }`}
        onClick={() => onSelect([])}
      >
        <Typography variant="body2" fontWeight={600}>All tests</Typography>
        <Typography variant="caption" color="text.secondary">
          {artifactCount} artifacts
        </Typography>
      </div>
      {tests.map((test) => {
        const key = testRowKey(test);
        const selected = selectedKeys.length === 1 && selectedKeys[0] === key;
        return (
          <div
            key={key}
            className={`border-b border-gray-200 py-3 cursor-pointer ${
              selected ? "bg-blue-50" : ""
            }`}
            onClick={() => onSelect([key])}
          >
            <div className="flex items-start justify-between gap-2">
              <Typography variant="body2" fontWeight={600}>{test.title}</Typography>
              <div className="flex items-center gap-1">
                <Chip size="small" label={`${test.artifactCount ?? 0} artifacts`} />
                {statusChip(test.status)}
              </div>
            </div>
            <Typography variant="caption" color="text.secondary">{test.spec}</Typography>
            {typeof test.durationMs === "number" && (
              <Typography variant="caption" display="block">{test.durationMs} ms</Typography>
            )}
            {typeof test.attempts === "number" && test.attempts > 1 && (
              <Typography variant="caption" display="block">
                {test.attempts} attempts
              </Typography>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RunTestList;
